import {Button, Card, CardActions, CardContent, Chip, Typography} from '@material-ui/core';
import React from 'react';
import {CardStyles} from './CardStyles';
import {Group, User} from '../../graphql';
import {Link} from 'react-router-dom';

interface GroupCardProps {
  group: Group,
}

export const GroupCard = ({group}: GroupCardProps) => {
  const classes = CardStyles();
  const disabled = !group.enabled;

  return <Card key={group.id} className={classes.card}>
    <CardContent>
      <Typography className={classes.title}>
        {group.name}
      </Typography>

      <Typography className={classes.pad10} component="div">
        {group?.users?.map((user: User | null) => (
          <Chip key={user?.id} size="small" className={classes.chip} label={user?.username}/>
        ))}
      </Typography>

      <Typography className={classes.info}>
        {group.id}<br/>
        {group.createdAt}<br/>
        {group.updatedAt}
      </Typography>
    </CardContent>

    <CardActions className={classes.actions}>
      <Link to={`/group/edit/${group.id}`}>
        <Button disabled={disabled} size="small">Edit</Button>
      </Link>
      {/*<Button size="small">Delete</Button>*/}
    </CardActions>

  </Card>;
};
